window.PlummeI18n.register('en', {
  'asset.reverse.from': 'Period from',
  'asset.reverse.to': 'Period to',
  'asset.reverse.filterHelp': 'Choose the period to inspect, then select the vouchers to reverse. Filtering never selects vouchers automatically. Select up to 100 vouchers at a time.',
  'asset.reverse.invalidRange': 'Choose a valid range of no more than ten years.',
  'asset.reverse.periodOverview': 'Period overview',
  'asset.reverse.status.posted': 'Posted',
  'asset.reverse.status.partial': 'Partly reversed',
  'asset.reverse.status.reversed': 'Reversed',
  'asset.reverse.status.empty': 'No recorded monthly entry',
  'asset.reverse.status.manual': 'Manual journal – correct from the transaction',
  'asset.reverse.legacyHelp': 'Older vouchers without a stored period breakdown appear in their accounting month. A combined voucher may also cover earlier months. Correct manual journals from their own transactions.',
  'asset.reverse.review': 'Review required before reversal',
  'asset.reverse.coverage': 'Recorded periods',
  'asset.reverse.dateOnly': 'based on accounting date',
  'asset.reverse.assets': 'Affected assets',
  'asset.reverse.wholeWarning': 'The whole voucher will be reversed. It affects other assets or periods outside the filter.',
  'asset.reverse.selected': '{count} selected vouchers – total amount',
  'asset.reverse.confirmWhole': 'I have reviewed and confirm reversal of the entire vouchers, including other periods and assets.',
  'asset.reverse.originalDates': 'Same date as each original voucher',
  'asset.reverse.commonDate': 'One common accounting date for the reversals',
  'asset.reverse.submit': 'Reverse selected vouchers',
  'err.asset.reverse.selectionInvalid': 'Review the selected vouchers, period, reversal dates and whole-voucher confirmation.',
});
